<script setup lang="ts">
const meta = inject('meta', ref())
const { strapiData, getStrapiData } = useStrapiCms(meta?.value?.strapi_id, undefined, 'blogDetail', 'blogDetail', meta?.value?.strapi_locale)
const { $t } = useI18n()

await getStrapiData()

const pageTitle = computed(
  () => strapiData.value?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.MetaData?.MetaTitle || pageTitle.value + ' | ' + $t('meta.title'),
)

const metaDescription = computed(
  () => strapiData.value?.MetaData?.MetaDescription || $t('meta.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: pageTitle.value,
  parents: meta.value.parents,
})

const { pageView } = useDataLayer()
pageView('blog-detail', metaTitle.value)

useHead({
  title: metaTitle,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'robots', content: strapiData.value?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
  script: [
    { type: 'application/ld+json', key: 'RichSnippets', innerHTML: strapiData.value?.MetaData?.RichSnippets || '' },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))
</script>

<template>
  <div
    v-if="strapiData"
    class="blog-detail"
  >
    <AppBreadcrumbs v-if="$route.path !== '/'" />

    <StrapiSlice
      class="blog-detail__header"
      :slice="{
        Settings: {
          SliceWidth: 'small-column',
          BackgroundColor: '#fff',
        },
      }"
      :index="0"
    >
      <BlogHeader :strapi-data="strapiData" />
    </StrapiSlice>

    <UiHeadingSection>
      <StrapiSlices
        v-if="strapiData?.Slices?.length"
        :slices="strapiData.Slices"
        :slice-offset="1"
      />
    </UiHeadingSection>

    <!--  -->
    <!--  -->
  </div>
</template>

<style>
@import url("~layers/pages/~blog-detail.css");
</style>
